import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from 'components/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTransition from 'components/DialogTransition';
import ResponsiveDialogHeader from 'components/ResponsiveDialogHeader';

import DatePicker from 'components/DatePicker';

import PrimaryDialogButton from 'components/PrimaryDialogButton';
import SecondaryDialogButton from 'components/SecondaryDialogButton';

import OutlinedTextField from 'components/OutlineTextField';
import OutlineFormattedTextField from 'components/OutlineFormattedTextField';
import FormElement from 'components/FormElement';
import Label from 'components/Label';
import { Body1 } from 'components/Typography';
import isStringSet from 'utilities/is/isStringSet';
import styles from './styles';
import m from 'messages';

import MultiplePersonMatchDialog from '../MultiplePersonMatchDialog';
import * as cardLookupActions from '../../actions';

class ManualLookupDialog extends React.Component {

    constructor(props) {
        super(props);

        this.state = this.initialState();
    }

    initialState() {
        return {
            surname: '',
            initial: '',
            dob: null,
            cardNumber: ''
        };
    }

    handleSubmit = () => {
        const formData = { ...this.state };
        this.setState(this.initialState());
        this.props.onSubmit(formData);
    };

    handleValueChanged = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    formatDate = (date) => {
        return date.toString();
    };

    isValid = () => {
        return isStringSet(this.state.surname)
            && isStringSet(this.state.initial)
            && (isStringSet(this.state.cardNumber) || this.state.dob != null);
    };

    handleKeyboardInput = (e) => {
        if (e.hasOwnProperty('keyCode') && e.keyCode === 13) {
            if (this.isValid()) {
                this.handleSubmit();
            }
        }
    };

    render() {

        let {
            classes,
            fullScreen,
            baseTitle,
            showMultipleMatchDialog,
            matches,
            dismissMultipleResultsDialog,
            selectMatch } = this.props;

        const isOpen = Boolean(this.props.open);

        return (
            <div>

                <MultiplePersonMatchDialog
                    open={showMultipleMatchDialog}
                    matches={matches}
                    handleClose={dismissMultipleResultsDialog}
                    select={(m) => selectMatch(m, this.props.context)}>

                </MultiplePersonMatchDialog>

                <Dialog
                    fullScreen={fullScreen}
                    open={isOpen}
                    TransitionComponent={DialogTransition}
                    className={classes.root}>
                    <ResponsiveDialogHeader
                        fullScreen={fullScreen}
                        title={m.manualLookup.title}
                        fullScreenTitle={baseTitle}
                        handleClose={this.props.handleClose}
                        showBackIcon={false} />
                    <DialogContent className={classes.contentRoot}>
                        <Body1 paragraph>
                            {m.manualLookup.preambleMessage}
                        </Body1>
                        <form onSubmit={this.handleSubmit}>
                            <FormElement className={classes.formElement} fullWidth>
                                <Label htmlFor="surname" required>
                                    {m.manualLookup.surnameLabel}
                                </Label>
                                <OutlinedTextField
                                    id="surname"
                                    autoFocus
                                    fullWidth
                                    name="surname"
                                    autoComplete="off"
                                    placeholder="Enter the Surname"
                                    onKeyUp={this.handleKeyboardInput}
                                    value={this.state.surname}
                                    onChange={this.handleValueChanged}
                                />
                            </FormElement>
                            <FormElement className={classes.formElement}>
                                <Label htmlFor="initial" required>
                                    {m.manualLookup.initialLabel}
                                </Label>
                                <OutlinedTextField
                                    name="initial"
                                    fullWidth={false}
                                    placeholder="Enter an Initial"
                                    autoComplete="off"
                                    onKeyUp={this.handleKeyboardInput}
                                    value={this.state.initial}
                                    onChange={this.handleValueChanged} />
                            </FormElement>
                            <br />
                            <Body1 paragraph>
                                {m.manualLookup.oneOfTheFollowing}
                            </Body1>
                            <FormElement className={classes.formElement} fullWidth>
                                <Label htmlFor="cardNumber">
                                    {this.props.cardNumberLabel}:
                                </Label>
                                <OutlineFormattedTextField
                                    name="cardNumber"
                                    value={this.state.cardNumber}
                                    autoComplete="off"
                                    fullWidth
                                    onKeyUp={this.handleKeyboardInput}
                                    placeholder={m.manualLookup.enterCardNumber(this.props.cardNumberLabel)}
                                    onChange={this.handleValueChanged}
                                    inputProps={{ format: "##-#########" }}
                                />
                            </FormElement>
                            <FormElement className={classes.formElement} fullWidth>
                                <Label htmlFor="initial">
                                    {m.manualLookup.dateOfBirthLabel}
                                </Label>
                                <DatePicker
                                    name="dob"
                                    disableFuture
                                    openTo="year"
                                    views={["year", "month", "date"]}
                                    value={this.state.dob}
                                    onKeyUp={this.handleKeyboardInput}
                                    onChange={(date) => this.setState({ dob: date })}
                                />
                            </FormElement>
                        </form>
                    </DialogContent>
                    <DialogActions fullScreen={fullScreen}>
                        {!fullScreen &&
                            <SecondaryDialogButton onClick={this.props.handleClose}>
                                {m.general.cancel}
                            </SecondaryDialogButton>
                        }
                        <PrimaryDialogButton disabled={!this.isValid()} onClick={() => this.props.onSubmit(this.state)}>
                            {m.general.find}
                        </PrimaryDialogButton>
                    </DialogActions>
                </Dialog>
            </div>);
    }
}

function mapStateToProps(state) {
    return {
        baseTitle: state.config.appName,
        matches: state.data.matches,
        showMultipleMatchDialog: Boolean(state.data.showMultipleMatchDialog),
        context: state.data.manualLookupDialogContext
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dismissMultipleResultsDialog: () => dispatch(cardLookupActions.hideMultipleMatchesDialog()),
        selectMatch: (match, context) => dispatch(cardLookupActions.selectMatchingCardholder(match, context))
    }
}
ManualLookupDialog.propTypes = {
    handleClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired
};

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps),
    withMobileDialog()
)(ManualLookupDialog);
